import { useGateway, useUser } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';
import { ModulePreview } from '@modules/remotes/preview';

export default function Preview({
  isShowroom,
}: Readonly<{ isShowroom?: boolean }>) {
  const user = useUser();
  const appConfig = getAppConfig();
  const gateway = useGateway();

  const apiConfig: MfPreviewConfig['apiConfig'] = {
    API_ROOT: appConfig?.API_ROOT || '',
    STAGE_HOST_LIVE: appConfig?.STAGE_HOST_LIVE || '',
    IMG_URL: appConfig?.IMG_URL || '',
    PREVIEW_NEUTRAL_HOST: appConfig?.PREVIEW_NEUTRAL_HOST || '',
    STAGE_HOST_PREVIEW: appConfig?.STAGE_HOST_PREVIEW || '',
    PREVIEW_F11_HOST: appConfig?.PREVIEW_F11_HOST || '',
    THEME_URL: appConfig?.THEME_URL || '',
    THEME_DEFAULT: appConfig?.THEME_DEFAULT || '',
  };

  const previewConfig: MfPreviewConfig = {
    apiConfig,
    gateway,
    isShowroom: !!isShowroom,
    user: {
      ...user,
      logout: () => gateway.logout(),
      id: String(user?.id ?? ''),
    },
  };

  return <ModulePreview {...previewConfig} />;
}
